export const MOBILE_WIDTH = 575;
export const BIG_MOBILE_WIDTH = 1199;
export const DEFAULT_CURRENCY_LIST_FILTERS: Record<string, string | null> = {
	name: null,
	endName: null,
	currency: null,
	level: null,
};
export const DEFAULT_NOTIFICATIONS_FILTERS: Record<string, string[] | string | null> = {
	name: null,
	endName: [],
	currency: null,
	level: [],
	change: null,
};

export const EMAIL_VALIDATION_PATTERN = '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$';

export const PATHS_WITHOUT_AUTHORIZATION: string[] = ['login', 'register', 'forgot-password'];
